<template>
  <div>
    <el-row>
      <TableContainer
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        ref="TableContainer"
      >
        <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加课程</el-button>
          </router-link>
        </template>

        <template v-slot:filter>
            <StudyClassSelect @onValueChanged="onStudyClassValueChanged"></StudyClassSelect>

          <!-- <selectTableFilterStatus
            @DoChange="DoChangeStatus"
            showReview
            showDraft
            ref="selectTableFilterStatusRef"
          ></selectTableFilterStatus>-->
        </template>

        <!--  -->
        <template v-slot:table__footer__info>课程列表</template>
      </TableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>




<script>
import Vue from 'vue'
import { TableContainer } from "@/core/table/";
import { StudyClassSelect } from "@/views/components/select"

export default {
  name: 'Course',
    
  components: {
    TableContainer,
    StudyClassSelect
  },
  
  data() {
    return {
      containerTableColumns: [
        {
          prop: "title",
          label: "名称",
          width: "300px"

        },
        {
          prop: "teacher",
          label: "教师",
          width: "300px"
        },
        {
          prop: "description",
          label: "课程介绍",
        }
      ],
      containerBaseUrl: "/course",
      containerServerUrl: "/api/manager/course",
      tableToolConfig: {
        canEdit: true,
        canRecover: true,
        canDelete: true,
        canDisable: true
      }
    }
  },
  
  methods: {
    onStudyClassValueChanged(sid) {
      if (this.$refs.TableContainer) {
        this.$refs.TableContainer.updateSid(sid)
      }
    }
  },
  
  mounted() {
    // 组件挂载后的逻辑
  }
}
</script>

<style scoped>
</style>